module.exports = __webpack_public_path__ + "img/Primordial-Process-6-mobile.e65d933d.png";